/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 26/08/2021 - 12:54:14
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 26/08/2021
    * - Author          :
    * - Modification    :
**/
import * as React from "react"

const Edit = (props) => {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.775 1.404a1.379 1.379 0 111.95 1.95L3.6 11.479l-2.6.65.65-2.6 8.125-8.125z"
        stroke="#24A95D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default React.memo(Edit)
